import { render, staticRenderFns } from "./URIEditor.vue?vue&type=template&id=019f8f82"
import script from "./URIEditor.vue?vue&type=script&lang=ts"
export * from "./URIEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports